          <div class="studio-cta reveal"{{{ root }}}>
            <p{{{ text.attrs }}}>{{{ text.html }}}</p>
            {{{ button }}}
          </div>
